module.exports = __webpack_public_path__ + "static/media/21.bbd3c196.JPG";